import { Injectable } from '@angular/core';
import { AccessConstants } from '../../../../../../core/constants/access-constants';
import { UserRole } from '../../../../../../core/enums/users/role';

@Injectable({
    providedIn: 'root',
})
export class OrderDetailsActionButtonVisibilityService {
    /**
     * Determines if action buttons requiring elevated roles should be visible based on the user's role.
     *
     * @param role The role of the current user.
     * @returns A boolean indicating if elevated role action buttons should be shown.
     */
    needsElevatedRoleActionButton(role: UserRole): boolean {
        return AccessConstants.RolesThatCanAccessAllOrders.includes(role);
    }

    /**
     * Determines if action buttons for non-elevated roles should be visible based on the user's role.
     *
     * @param role The role of the current user.
     * @returns A boolean indicating if non-elevated role action buttons should be shown.
     */
    needsNonElevatedRoleActionButton(role: UserRole): boolean {
        return role === UserRole.Customer;
    }
}
